// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Checklist_wrapper__2vlRr","label":"Checklist_label__3OfyA"};